import type { ResourceConfig } from "../types";

export const orderAttributionConfig = {
  displayName: "订单归因",
  category: "order-attribution",
  permissions: {
    "read:all": {
      label: "查看所有订单归因",
      description: "可以查看系统中所有订单的归因信息",
    },
    "write:all": {
      label: "编辑所有订单归因",
      description: "可以创建和编辑所有订单的归因信息",
    },
    "read:assigned": {
      label: "查看自己的订单归因",
      description: "只能查看自己参与归因的记录",
    },
  },
  scopeStrategy: "byAttributionStaff",
} satisfies ResourceConfig;
